import type { SVGProps } from 'react';

const TrendingDown = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8333 6.83335L9.16666 3.16669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8333 12.8334H12.1667C12.5349 12.8334 12.8333 12.535 12.8333 12.1668V10.5C12.8333 10.1318 12.5349 9.83331 12.1667 9.83331H11.8333C11.4651 9.83331 11.1667 10.1318 11.1667 10.5V12.1668C11.1667 12.535 11.4651 12.8334 11.8333 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83333 12.8334H8.16666C8.53486 12.8334 8.83333 12.535 8.83333 12.1668V8.49998C8.83333 8.13178 8.53486 7.83331 8.16666 7.83331H7.83333C7.46513 7.83331 7.16666 8.13178 7.16666 8.49998V12.1668C7.16666 12.535 7.46513 12.8334 7.83333 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.83333 12.8335H4.16666C4.53486 12.8335 4.83333 12.535 4.83333 12.1668V3.83335C4.83333 3.46517 4.53486 3.16669 4.16666 3.16669H3.83333C3.46514 3.16669 3.16666 3.46517 3.16666 3.83335V12.1668C3.16666 12.535 3.46514 12.8335 3.83333 12.8335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8333 4.5V6.83333H10.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrendingDown;
